import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useStore } from './store/authStore'
import Layout from './layouts/Layout'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import DevicesPage from './pages/DevicesPage'
import ServiceVisitsPage from './pages/ServiceVisitsPage'
import CustomersPage from './pages/CustomersPage'
import ProfilePage from './pages/ProfilePage'
import UsersPage from './pages/UsersPage'
import ErrorsPage from './pages/ErrorsPage'
import BackupPage from './pages/BackupPage'
import SiteSettingsPage from './pages/SiteSettingsPage'

function App() {
  const { isAuthenticated, isLoading, checkAuth } = useStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />
        }
      />
      <Route
        path="/"
        element={
          isAuthenticated ? <Layout /> : <Navigate to="/login" replace />
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="service-visits" element={<ServiceVisitsPage />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="site-settings" element={<SiteSettingsPage />} />
        <Route path="errors" element={<ErrorsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="backup" element={<BackupPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
